/* SoPoly modern PDP: sticky add-to-cart bar behaviour */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.sp-pdp');
    if (!root) return;
    var bar = root.querySelector('.sticky-cart-wr');
    var atc = root.querySelector('.product-form__cart-submit');
    if (!bar || !atc) return;

    // Mobile summary (current color + price) inside the sticky bar
    var prd = bar.querySelector('#js-sticky-prd');
    var btn = bar.querySelector('#js-sticky-btn');
    var mobile = document.createElement('div');
    mobile.className = 'sp-sticky-mobile';
    mobile.innerHTML = '<span class="sp-sticky-mobile__color"></span><span class="sp-sticky-mobile__price"></span>';
    if (prd && btn) prd.insertBefore(mobile, btn);

    function sync() {
      var priceEl = root.querySelector('.product-single__price:not(.product-single__price--compare)');
      var colorEl = root.querySelector('[data-color-swatch-current-name]');
      var stickyPrice = bar.querySelector('#js-sticky-price');
      if (priceEl) {
        var p = priceEl.textContent.trim();
        mobile.querySelector('.sp-sticky-mobile__price').textContent = p;
        if (stickyPrice) stickyPrice.textContent = p;
      }
      mobile.querySelector('.sp-sticky-mobile__color').textContent = colorEl ? colorEl.textContent.trim() : '';
    }
    sync();
    root.addEventListener('change', function () { setTimeout(sync, 60); }, true);
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-color-swatch-item]')) setTimeout(sync, 60);
    });

    // Show the bar only once the main Add to Cart button has scrolled out of view (above the fold)
    function update() {
      var r = atc.getBoundingClientRect();
      var footer = document.querySelector('[id$="__footer"].shopify-section');
      var nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
      bar.classList.toggle('active', r.bottom < 0 && !nearFooter);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
